var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsiteCreatorRafiki(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-39"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.93,98.14A4.88,4.88,0,0,0,349,93.25a5.06,5.06,0,0,0-1.41.2,10.59,10.59,0,0,0,.11-1.5A10.35,10.35,0,0,0,337.39,81.6a10.94,10.94,0,0,0-1.91.17,9.05,9.05,0,0,0-16.78,4.58h-.15a8.35,8.35,0,0,0,0,16.69h30.62A4.9,4.9,0,0,0,353.93,98.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.95 105.45 335.95 95.92 328.18 95.92 328.18 105.45 321.85 105.45 332.07 114.09 342.29 105.45 335.95 105.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.68,112.56a10.39,10.39,0,0,0-10.38-10.39,10.55,10.55,0,0,0-3,.44,20.92,20.92,0,0,0,.24-3.19,22,22,0,0,0-22-22,21.72,21.72,0,0,0-4.05.38,19.22,19.22,0,0,0-35.64,9.72l-.32,0a17.72,17.72,0,1,0,0,35.43h65.05A10.38,10.38,0,0,0,200.68,112.56Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146 113.36 146 133.61 162.51 133.61 162.51 113.36 175.96 113.36 154.25 95.02 132.55 113.36 146 113.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "208.97 163.13 208.97 135.9 292.35 135.9 292.35 162.86",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.89,
    y1: 110.24,
    x2: 251.89,
    y2: 163.06,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.53,
    y: 99.87,
    width: 30.74,
    height: 19.25,
    rx: 1.19,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.59,
    y: 102.13,
    width: 28.61,
    height: 16.22,
    rx: 0.42,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.6,
    y: 160.66,
    width: 30.74,
    height: 19.25,
    rx: 1.19,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.66,
    y: 162.92,
    width: 28.61,
    height: 16.22,
    rx: 0.42,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.53,
    y: 160.66,
    width: 30.74,
    height: 19.25,
    rx: 1.19,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.59,
    y: 162.92,
    width: 28.61,
    height: 16.22,
    rx: 0.42,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.05,
    y: 160.66,
    width: 30.74,
    height: 19.25,
    rx: 1.19,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.11,
    y: 162.92,
    width: 28.61,
    height: 16.22,
    rx: 0.42,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.65,
    y: 129.66,
    width: 12.48,
    height: 12.48,
    rx: 0.81,
    transform: "translate(-22.32 217.92) rotate(-45)",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.21,
    y: 122.65,
    width: 21.75,
    height: 13.03,
    rx: 0.87,
    style: {
      fill: "#e0e0e0",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.1,
    y: 150.68,
    width: 17.59,
    height: 9.95,
    rx: 0.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.79,
    y: 150.68,
    width: 17.59,
    height: 9.95,
    rx: 0.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.74,
    y: 171.74,
    width: 9.23,
    height: 8.5,
    rx: 0.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.46,
    y: 171.74,
    width: 9.23,
    height: 8.5,
    rx: 0.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.19,
    y: 171.74,
    width: 9.23,
    height: 8.5,
    rx: 0.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.61,
    y: 171.74,
    width: 9.23,
    height: 8.5,
    rx: 0.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.33,
    y: 171.74,
    width: 9.23,
    height: 8.5,
    rx: 0.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.58 150.68 92.58 150.68 92.58 143.68 79.58 143.68 79.58 135.68 78.58 135.68 78.58 143.68 65.58 143.68 65.58 150.68 66.58 150.68 66.58 144.68 91.58 144.68 91.58 150.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.58 166.68 52.58 166.68 52.58 171.68 53.58 171.68 53.58 167.68 65.58 167.68 65.58 171.68 66.58 171.68 66.58 160.68 65.58 160.68 65.58 166.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.58 167.68 92.58 160.68 91.58 160.68 91.58 167.68 79.58 167.68 79.58 171.68 80.58 171.68 80.58 168.68 91.58 168.68 91.58 171.68 92.58 171.68 92.58 168.68 103.58 168.68 103.58 171.68 104.58 171.68 104.58 167.68 92.58 167.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,125.78V133l3.7.35a19.32,19.32,0,0,0,2.76,6.64l-2.38,2.87,5.08,5.08,2.87-2.38a19.13,19.13,0,0,0,6.64,2.76L400,152h7.18l.35-3.7a19.13,19.13,0,0,0,6.64-2.76l2.87,2.38,5.08-5.08L419.75,140a19.32,19.32,0,0,0,2.76-6.64l3.7-.35v-7.18l-3.7-.35a19.19,19.19,0,0,0-2.76-6.63l2.38-2.87-5.08-5.08-2.87,2.37a19.32,19.32,0,0,0-6.64-2.76l-.35-3.7H400l-.35,3.7a19.32,19.32,0,0,0-6.64,2.76l-2.87-2.37-5.08,5.08,2.38,2.87a19.19,19.19,0,0,0-2.76,6.63Zm22.61-6.13a9.73,9.73,0,1,1-9.73,9.72A9.73,9.73,0,0,1,403.6,119.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.63,178.2a15.07,15.07,0,0,0,5.2-2.17l2.25,1.87,4-4-1.86-2.25a15.13,15.13,0,0,0,2.16-5.2l2.9-.28v-5.63l-2.9-.27a15.05,15.05,0,0,0-2.16-5.2l1.86-2.25-4-4-2.25,1.86a15.05,15.05,0,0,0-5.2-2.16l-.27-2.9h-5.63l-.27,2.9a15.05,15.05,0,0,0-5.2,2.16L372,148.86l-4,4,1.86,2.25a15.05,15.05,0,0,0-2.16,5.2l-2.9.27v5.63l2.9.28a15.13,15.13,0,0,0,2.16,5.2L368,173.92l4,4,2.25-1.87a15.07,15.07,0,0,0,5.2,2.17l.27,2.89h5.63Zm-10.71-14.82a7.63,7.63,0,1,1,7.63,7.62A7.63,7.63,0,0,1,374.92,163.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.07,147.73l1.89,1.56,3.35-3.34-1.57-1.89a12.62,12.62,0,0,0,1.82-4.37l2.43-.23v-4.72l-2.43-.23a12.62,12.62,0,0,0-1.82-4.37l1.57-1.89L375,124.91l-1.89,1.56a12.66,12.66,0,0,0-4.36-1.82l-.23-2.43h-4.73l-.23,2.43a12.62,12.62,0,0,0-4.37,1.82l-1.89-1.56-3.34,3.34,1.56,1.89a12.61,12.61,0,0,0-1.81,4.37l-2.44.23v4.72l2.44.23a12.61,12.61,0,0,0,1.81,4.37L353.92,146l3.34,3.34,1.89-1.56a12.42,12.42,0,0,0,4.37,1.81l.23,2.44h4.73l.23-2.44A12.45,12.45,0,0,0,373.07,147.73ZM359.71,137.1a6.4,6.4,0,1,1,6.4,6.4A6.4,6.4,0,0,1,359.71,137.1Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.24,
    y: 324.03,
    width: 67.15,
    height: 43.67,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.69,
    y: 332.22,
    width: 62.23,
    height: 33.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.76,
    y: 337.2,
    width: 46.04,
    height: 1.43,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.76,
    y: 341.58,
    width: 22.09,
    height: 1.43,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.76,
    y: 345.97,
    width: 27.82,
    height: 1.43,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.76,
    y: 350.36,
    width: 9.8,
    height: 1.43,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.76,
    y: 354.75,
    width: 6.35,
    height: 1.43,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.88,
    y: 323.89,
    width: 47.78,
    height: 29.47,
    transform: "translate(-1.54 0.33) rotate(-0.26)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.14,346.06a1,1,0,0,1-.59-.19l-8.71-6.37a1,1,0,0,1-.41-.8,1,1,0,0,1,.4-.81l8.66-6.45a1,1,0,1,1,1.19,1.61l-7.57,5.64,7.62,5.56a1,1,0,0,1-.59,1.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.46,346a1,1,0,0,1-.81-.4,1,1,0,0,1,.21-1.4l7.57-5.64L76.81,333A1,1,0,1,1,78,331.39l8.71,6.36a1,1,0,0,1,.41.81,1,1,0,0,1-.4.8l-8.66,6.45A1,1,0,0,1,77.46,346Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52,346.05a1,1,0,0,1-.33-.06,1,1,0,0,1-.61-1.27l4.49-12.84a1,1,0,1,1,1.89.66l-4.49,12.84A1,1,0,0,1,69.52,346.05Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-39"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.2,
    y: 371.85,
    width: 67.15,
    height: 43.67,
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.2,
    y: 371.85,
    width: 67.15,
    height: 43.67,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.66,
    y: 380.04,
    width: 62.24,
    height: 33.3,
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.73,
    y: 385.01,
    width: 46.04,
    height: 1.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.73,
    y: 389.4,
    width: 22.09,
    height: 1.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.73,
    y: 393.79,
    width: 27.82,
    height: 1.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.73,
    y: 398.17,
    width: 9.8,
    height: 1.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.73,
    y: 402.56,
    width: 6.35,
    height: 1.43,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "277.33 416.24 222.67 416.24 231.92 343.57 268.08 343.57 277.33 416.24",
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.33 416.24 222.67 416.24 229 366.52 231.93 343.57 268.07 343.57 272.39 377.43 277.33 416.24",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.39 377.43 229 366.52 231.93 343.57 268.07 343.57 272.39 377.43",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.87,164.38H121.13a6.59,6.59,0,0,0-6.59,6.6V345.46a6.59,6.59,0,0,0,6.59,6.59H378.87a6.59,6.59,0,0,0,6.59-6.59V171A6.59,6.59,0,0,0,378.87,164.38Z",
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.87,164.38H121.13a6.59,6.59,0,0,0-6.59,6.6V345.46a6.59,6.59,0,0,0,6.59,6.59H378.87a6.59,6.59,0,0,0,6.59-6.59V171A6.59,6.59,0,0,0,378.87,164.38Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.22,
    y: 170.84,
    width: 253.57,
    height: 168.25,
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.05,
    y: 410.78,
    width: 93.89,
    height: 5.37,
    rx: 1.04,
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.05,
    y: 410.78,
    width: 93.89,
    height: 5.37,
    rx: 1.04,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.22,
    y: 171,
    width: 253.57,
    height: 25.08,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.22,
    y: 196.38,
    width: 108.66,
    height: 142.71,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "337.76 232.78 337.76 235.28 335.26 235.28",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 329.98,
    y1: 235.28,
    x2: 248.08,
    y2: 235.28,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeDasharray: "5.283740043640137,5.283740043640137"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "245.44 235.28 242.94 235.28 242.94 232.78",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.94,
    y1: 228.25,
    x2: 242.94,
    y2: 185.22,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeDasharray: "4.529409885406494,4.529409885406494"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "242.94 182.96 242.94 180.46 245.44 180.46",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.72,
    y1: 180.46,
    x2: 332.62,
    y2: 180.46,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeDasharray: "5.283740043640137,5.283740043640137"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "335.26 180.46 337.76 180.46 337.76 182.96",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.76,
    y1: 187.49,
    x2: 337.76,
    y2: 230.52,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeDasharray: "4.529409885406494,4.529409885406494"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.18,
    y: 178.87,
    width: 3.17,
    height: 3.17,
    style: {
      fill: "#FFE872",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.18,
    y: 233.7,
    width: 3.17,
    height: 3.17,
    style: {
      fill: "#FFE872",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.35,
    y: 178.87,
    width: 3.17,
    height: 3.17,
    style: {
      fill: "#FFE872",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.35,
    y: 233.7,
    width: 3.17,
    height: 3.17,
    style: {
      fill: "#FFE872",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.77,
    y: 178.87,
    width: 3.17,
    height: 3.17,
    style: {
      fill: "#FFE872",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.77,
    y: 233.7,
    width: 3.17,
    height: 3.17,
    style: {
      fill: "#FFE872",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.18,
    y: 206.28,
    width: 3.17,
    height: 3.17,
    style: {
      fill: "#FFE872",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.35,
    y: 206.28,
    width: 3.17,
    height: 3.17,
    style: {
      fill: "#FFE872",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.05,
    y: 198.87,
    width: 26.99,
    height: 9.99,
    rx: 1.89,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.05,
    y: 198.87,
    width: 26.99,
    height: 9.99,
    rx: 1.89,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.56,
    y: 320.46,
    width: 26.99,
    height: 9.99,
    rx: 1.89,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.05,
    y1: 179.92,
    x2: 368.49,
    y2: 179.92,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.05,
    y1: 183.92,
    x2: 368.49,
    y2: 183.92,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.05,
    y1: 187.92,
    x2: 368.49,
    y2: 187.92,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.41,
    y: 218.5,
    width: 85.05,
    height: 85.05,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.01,
    y1: 225.45,
    x2: 176.01,
    y2: 298.82,
    style: {
      fill: "none",
      stroke: "#FFE872",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.69,298.82h0A36.69,36.69,0,0,1,176,262.13h0a36.68,36.68,0,0,1,36.68-36.68h0",
    style: {
      fill: "none",
      stroke: "#FFE872",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.11,
    y: 223.87,
    width: 3.17,
    height: 3.17,
    style: {
      fill: "#fff",
      stroke: "#FFE872",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.11,
    y: 297.23,
    width: 3.17,
    height: 3.17,
    style: {
      fill: "#fff",
      stroke: "#FFE872",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.43,
    y: 260.55,
    width: 3.17,
    height: 3.17,
    style: {
      fill: "#fff",
      stroke: "#FFE872",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.83,225.45a.82.82,0,1,1-.82-.82A.83.83,0,0,1,176.83,225.45Z",
    style: {
      fill: "#fff",
      stroke: "#FFE872",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.83,298.82A.82.82,0,1,1,176,298,.82.82,0,0,1,176.83,298.82Z",
    style: {
      fill: "#fff",
      stroke: "#FFE872",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.93,321.67H291.18a7.44,7.44,0,0,1-7.44-7.44h0a7.44,7.44,0,0,1,7.44-7.44h25.75a7.44,7.44,0,0,1,7.44,7.44h0A7.44,7.44,0,0,1,316.93,321.67Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.55,258.22H260a1.63,1.63,0,0,1-1.63-1.63h0A1.62,1.62,0,0,1,260,255h79.54a1.62,1.62,0,0,1,1.63,1.62h0A1.63,1.63,0,0,1,339.55,258.22Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.55,270.09H260a1.62,1.62,0,0,1-1.63-1.62h0a1.63,1.63,0,0,1,1.63-1.63h79.54a1.63,1.63,0,0,1,1.63,1.63h0A1.62,1.62,0,0,1,339.55,270.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.55,282H290a1.63,1.63,0,0,1-1.63-1.62h0a1.63,1.63,0,0,1,1.63-1.63h49.54a1.63,1.63,0,0,1,1.63,1.63h0A1.63,1.63,0,0,1,339.55,282Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.23,
    y: 177.95,
    width: 5.62,
    height: 5.62,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.15,
    y: 177.95,
    width: 5.62,
    height: 5.62,
    rx: 1.44,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.08,
    y: 177.95,
    width: 5.62,
    height: 5.62,
    rx: 2.57,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.45,316.5v-2.19l-1.12-.1a6.18,6.18,0,0,0-.84-2l.72-.87-1.55-1.55-.87.72a6.18,6.18,0,0,0-2-.84l-.1-1.12h-2.19l-.11,1.12a6.22,6.22,0,0,0-2,.84l-.87-.72-1.55,1.55.72.87a5.78,5.78,0,0,0-.84,2l-1.13.1v2.19l1.13.11a5.81,5.81,0,0,0,.84,2l-.72.88,1.55,1.54.87-.72a5.81,5.81,0,0,0,2,.84l.11,1.13h2.19l.1-1.13a5.78,5.78,0,0,0,2-.84l.87.72,1.55-1.54-.72-.88a6,6,0,0,0,.84-2Zm-6.89,1.87a3,3,0,1,1,3-3A3,3,0,0,1,141.56,318.37Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.33,322.68V321l-.88-.09a4.61,4.61,0,0,0-.66-1.58l.56-.69-1.21-1.21-.68.57a4.66,4.66,0,0,0-1.59-.66l-.08-.89h-1.72l-.08.89a4.66,4.66,0,0,0-1.59.66l-.68-.57-1.22,1.21.57.69a4.61,4.61,0,0,0-.66,1.58l-.88.09v1.71l.88.09a4.61,4.61,0,0,0,.66,1.58l-.57.69,1.22,1.21.68-.57a4.66,4.66,0,0,0,1.59.66l.08.88h1.72l.08-.88a4.66,4.66,0,0,0,1.59-.66l.68.57,1.21-1.21-.56-.69a4.61,4.61,0,0,0,.66-1.58Zm-5.4,1.47a2.33,2.33,0,1,1,2.32-2.33A2.32,2.32,0,0,1,151.93,324.15Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.45,327.55v-1.44l-.74-.07a3.9,3.9,0,0,0-.55-1.33l.48-.57-1-1-.58.47a3.9,3.9,0,0,0-1.33-.55l-.07-.74H143.2l-.07.74a3.9,3.9,0,0,0-1.33.55l-.58-.47-1,1,.48.57a3.9,3.9,0,0,0-.55,1.33l-.75.07v1.44l.75.07a3.87,3.87,0,0,0,.55,1.34l-.48.57,1,1,.58-.48a3.73,3.73,0,0,0,1.33.56l.07.74h1.44l.07-.74a3.73,3.73,0,0,0,1.33-.56l.58.48,1-1-.48-.57a3.87,3.87,0,0,0,.55-1.34Zm-4.53,1.23a1.95,1.95,0,1,1,2-1.95A1.95,1.95,0,0,1,143.92,328.78Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.18 179.89 341.42 191.23 348.51 184.13 337.18 179.89",
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.85,
    y: 185.2,
    width: 2.24,
    height: 4.97,
    transform: "translate(-31.67 298.9) rotate(-45)",
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.51 184.13 337.18 179.89 341.42 191.23 344.18 188.47 345.93 190.23 347.51 188.65 345.76 186.89 348.51 184.13",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.46,220.42l10.67,4-5.59-5.59a1.09,1.09,0,0,1-1.31-.17,1.1,1.1,0,0,1,1.56-1.56,1.09,1.09,0,0,1,.17,1.31l5.59,5.59-4-10.67-3.54.78-.13-1.27-.67-.67-3.92,3.92.67.67,1.28.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.46,220.42l10.67,4-5.59-5.59a1.09,1.09,0,0,1-1.31-.17,1.1,1.1,0,0,1,1.56-1.56,1.09,1.09,0,0,1,.17,1.31l5.59,5.59-4-10.67-3.54.78-.13-1.27-.67-.67-3.92,3.92.67.67,1.28.13Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "160.3 170.84 122.72 311.26 122.72 170.84 160.3 170.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.71 170.84 157.68 339.09 126.66 339.09 171.68 170.84 202.71 170.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.81 170.84 202.78 339.09 188.75 339.09 233.78 170.84 247.81 170.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.34 170.84 244.31 339.09 239.29 339.09 284.32 170.84 289.34 170.84",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "55.36 408.67 62.77 408.67 63.38 391.51 55.97 391.51 55.36 408.67",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.79,407.81h-9a.63.63,0,0,0-.63.51l-1.46,6.59a1.09,1.09,0,0,0,.84,1.3l.24,0c2.91-.05,5-.23,8.68-.23,2.26,0,9,.24,12.16.24s3.51-3.07,2.24-3.35c-5.71-1.25-10-3-11.83-4.61A1.8,1.8,0,0,0,63.79,407.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3,408.84a.18.18,0,0,1-.13-.15.16.16,0,0,1,.08-.17c.27-.17,2.66-1.64,3.48-1.22a.52.52,0,0,1,.3.49,1,1,0,0,1-.37.94,2.15,2.15,0,0,1-1.42.38A9.16,9.16,0,0,1,64.3,408.84Zm.51-.25a3.6,3.6,0,0,0,2.64-.13.72.72,0,0,0,.23-.63c0-.14-.06-.21-.11-.21a.46.46,0,0,0-.23-.05A7.25,7.25,0,0,0,64.81,408.59Z",
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.25,408.87a.18.18,0,0,1-.08-.16c0-.1.19-2.23,1-2.93a.9.9,0,0,1,.74-.22.59.59,0,0,1,.57.46c.15.78-1.33,2.41-2.1,2.83h-.08ZM65.44,406a4.16,4.16,0,0,0-.87,2.32c.76-.58,1.7-1.81,1.61-2.29,0,0,0-.18-.26-.18h-.08A.59.59,0,0,0,65.44,406Z",
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.97 391.52 63.38 391.52 63.06 400.37 55.65 400.37 55.97 391.52",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.49 409.22 101.14 410.03 102.57 393.55 94.93 392.74 93.49 409.22",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.94,407.57H93a.65.65,0,0,0-.63.51l-1.46,6.6A1.08,1.08,0,0,0,91.7,416l.24,0c2.91-.05,5-.23,8.69-.23,2.25,0,9,.23,12.15.23s3.51-3.07,2.24-3.35c-5.71-1.24-10-3-11.83-4.61A1.85,1.85,0,0,0,101.94,407.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.45,408.6a.18.18,0,0,1-.13-.15.15.15,0,0,1,.09-.17c.26-.17,2.65-1.64,3.47-1.21a.5.5,0,0,1,.3.48,1.06,1.06,0,0,1-.36.95,2.25,2.25,0,0,1-1.43.37A9.16,9.16,0,0,1,102.45,408.6Zm.51-.24a3.6,3.6,0,0,0,2.64-.14.71.71,0,0,0,.23-.63c0-.14-.06-.2-.11-.2a.36.36,0,0,0-.22-.05A7,7,0,0,0,103,408.36Z",
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.41,408.64a.19.19,0,0,1-.09-.16c0-.11.19-2.23,1.05-2.93a1,1,0,0,1,.74-.23.58.58,0,0,1,.57.46c.15.79-1.33,2.42-2.1,2.83h-.08Zm1.18-2.88a4.13,4.13,0,0,0-.87,2.31c.76-.57,1.7-1.81,1.61-2.29,0,0,0-.18-.26-.18H104A.65.65,0,0,0,103.59,405.76Z",
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.93 392.74 102.57 393.55 101.82 402.05 94.18 401.24 94.93 392.74",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,241.05H98.33c3.73,20.41,15.43,92.62,7,157l-13.31-1.65s1.23-85.41-10.51-117c-1.35,16.9-3,34.88-4.35,44.45-3.42,23.55-10.74,75-10.74,75H52.91s2.77-49.26,4.05-72.4C58.36,301.3,59,246.21,59,241.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.89 401.11 90.42 398.66 90.93 394.1 108.06 396.35 106.89 401.11",
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.09 398.94 52.11 398.94 52.11 394.17 68.69 393.86 68.09 398.94",
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.55,279.37a106.24,106.24,0,0,1,4.39,17c1.1-15-3.3-31-3.3-31Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.91,247.89l-.9,4.75s27.51,3.56,44.62,3.46l-.6-3.26Z",
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.74,206.76s9.51,30,16,32,23-22.79,23-22.79,14.83-.14,15.49-1.15-3.85-11.46-4.93-11.47-14,4.85-14.49,5.67-15.32,15-16,14.58-6.32-18.25-6.32-18.25Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.7,214.35a3.58,3.58,0,0,0,.35-.09l-.17-.11A1.71,1.71,0,0,1,154.7,214.35Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.34,203.3l1.16,2.13,5.41,10,1.13,2.07,15.19-5.28s-6.32-23.58-8.51-26Z",
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.34,203.3l1.16,2.13,5.41,10,1.13,2.07,15.19-5.28s-6.32-23.58-8.51-26Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5,205.43l5.41,10c3.35-6.57,2.38-15.57,2.38-15.57Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.72,186.23a32.24,32.24,0,0,0-22.88-11.1c-14.88-.7-19.56.78-25,5.64C66.89,187.87,57,249,57,249a138.07,138.07,0,0,0,44.62,4.85s.18-17,5.55-28.41A317.08,317.08,0,0,0,122.72,186.23Z",
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,249a138.23,138.23,0,0,0,44.62,4.86s0-2.1.29-5.31c.12-1.52.3-3.3.55-5.22s.61-4.11,1-6.29c.24-1.17.52-2.35.82-3.52a46.86,46.86,0,0,1,2.84-8.09c.66-1.4,1.3-2.79,1.92-4.15,1.07-2.38,2.09-4.69,3-6.9,2-4.65,3.7-8.9,5.12-12.62,1-2.67,1.9-5.06,2.63-7.11.81-2.29,1.45-4.17,1.92-5.57.61-1.85.91-2.86.91-2.86a19.58,19.58,0,0,0-1.6-1.77,32.54,32.54,0,0,0-20.78-9.3l-.5,0c-11.34-.53-16.75.2-21.09,2.73a23.93,23.93,0,0,0-3.91,2.92A13.28,13.28,0,0,0,72.12,185a92,92,0,0,0-4.54,13.26l-.66,2.43c-1,3.71-1.94,7.66-2.84,11.66-.26,1.14-.51,2.28-.76,3.41-.37,1.74-.74,3.47-1.09,5.18-.9,4.31-1.71,8.49-2.42,12.25-1,5.4-1.81,9.92-2.29,12.73C57.19,247.9,57,249,57,249Zm43.7-73.3a29.38,29.38,0,0,1,3,.23c4,.54,10.15,3.75,10,5.27s-2.49,5.4-8.47,4.46a14.88,14.88,0,0,1-5.8-2.42c-3.3-2.18-5.7-5.13-5.94-6.09C93.19,176,97.07,175.61,100.71,175.72Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.88,196.08S80,215.15,78.38,231l21.31,2.72s9.56-25.77,11.54-33.83C111.23,199.87,94.21,198.17,87.88,196.08Z",
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.07 200.62 110.03 200.91 107.86 202.59 107.07 200.62",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.47,177.2c1.61,4.6,7.6,6.7,10.74,7a5.34,5.34,0,0,0,5.7-3.08s-3.59-1.79-3.23-3.8a9.18,9.18,0,0,1,1.48-3.42,18.08,18.08,0,0,1,1.22-1.69l-5.75-12.33C104.35,165.22,100.42,175.48,95.47,177.2Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.4,165.57c-2.74,6,1.13,10.13,3.28,11.71a9.18,9.18,0,0,1,1.48-3.42Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.68,149.56s1.84,10.16-3.46,14.23-5.84-14.91-5.84-14.91Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.68,149.56s1.84,10.16-3.46,14.23-5.84-14.91-5.84-14.91Z",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.73,172.34a9.26,9.26,0,0,0,10.73,3.29,10.32,10.32,0,0,0,5.75-5c.17-.31.32-.65.47-1,2.48-6.31,3-21.71-3.68-21.14-5.52.47-10.92-1.23-13.74,3.54a10,10,0,0,0-1.38,4.46C103.28,163.85,102.58,168.12,105.73,172.34Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.61,160.13c-.12.58.16,1.11.55,1.17s.77-.39.86-1-.17-1.11-.55-1.16S114.7,159.53,114.61,160.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.3,161.08c-.12.58.17,1.11.55,1.17s.77-.39.85-1-.16-1.11-.55-1.17S121.38,160.52,121.3,161.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.13,161.07a21.45,21.45,0,0,0,2.11,5.46,3.47,3.47,0,0,1-2.92.13Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.85,157.67a.35.35,0,0,0,.35-.09,2.84,2.84,0,0,1,2.39-.84.36.36,0,0,0,.42-.27.34.34,0,0,0-.27-.41h0a3.51,3.51,0,0,0-3,1,.36.36,0,0,0,0,.5h0A.6.6,0,0,0,112.85,157.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.5,159.18a.28.28,0,0,0,.2,0,.33.33,0,0,0,.23-.43h0a3.47,3.47,0,0,0-2.22-2.3.34.34,0,0,0-.43.24h0a.35.35,0,0,0,.24.43h0a2.84,2.84,0,0,1,1.74,1.85A.34.34,0,0,0,124.5,159.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.68,166.92s1.23,2.64,3.74,2.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.49,148.23l.1,3.26a2.4,2.4,0,0,0-1.49,2.91c.78,2.8-1.15,6.86-3.38,8.34,0,0,0-1.18-1-1s-1.31,6.32.34,9.41c0,0-3.53-3.25-4.58-9.82-1-6.07-.81-9.92,0-12.83Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.49,148.23l.1,3.26a2.4,2.4,0,0,0-1.49,2.91c.78,2.8-1.15,6.86-3.38,8.34,0,0,0-1.18-1-1s-1.31,6.32.34,9.41c0,0-3.53-3.25-4.58-9.82-1-6.07-.81-9.92,0-12.83Z",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.92,152.14a33.88,33.88,0,0,0,10.67-.65c10.07-2,14.36,1.7,14.36,1.7a6.33,6.33,0,0,0,2.09-5c-.29-2.9-4.32-3.39-4.32-3.39s-1.21-3.27-3.88-4.26-5.35,1.49-5.35,1.49-3.33-3.22-7.21-2.3a5.82,5.82,0,0,0-4.65,5.66s-4.55.46-4.45,2.8S99.92,152.14,99.92,152.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.39,
    cy: 160.62,
    rx: 3.27,
    ry: 3.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.88,161.18a3.3,3.3,0,1,1-3.27-3.77A3.55,3.55,0,0,1,126.88,161.18Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.65,161.07s1.06-.66,1.69.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.12,160.62l-5.73-.77a2.86,2.86,0,0,0-2.11.57l-.25.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.86,162a7,7,0,0,0,3.47,4.06c2.19,1.09,3.75-.75,3.53-3.06-.2-2.06-1.57-5.16-4-5.28A3.12,3.12,0,0,0,99.86,162Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.32,215.79c9.44-3.92,16.9-20.11,16.9-20.11l-5.36-3.24-7.28,5.85-.66,2.43c-1,3.71-1.94,7.66-2.84,11.66C63.82,213.52,63.57,214.66,63.32,215.79Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.31 217.51 131.59 211.53 132.06 212.91 115.77 218.71 115.31 217.51",
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.32,
    y: 254.74,
    width: 47.78,
    height: 29.47,
    transform: "translate(42.8 -4.07) rotate(9.01)",
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.63 262.26 33.04 267.23 40.62 274.92",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "51.79 276.69 61.37 271.72 53.8 264.03",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.96,
    y1: 275.45,
    x2: 50.46,
    y2: 263.5,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.21,183.38S51.42,201.23,49,204.7s-7.06,41.94-7.06,41.94-1,.34-1.06,1.17-.16,11.63,0,12.13,8.34,5.55,9.55,4.35,2.89-13.43,2.89-13.43L49,246.64s5-28.33,8.17-32.92,16.09-14.41,16.09-14.41Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.88,176.19c2.59,5.49.62,17.05-4.16,21.13a140,140,0,0,1-16,11.47L54,197.36s9.28-9.06,14.9-14.28A25.39,25.39,0,0,1,82.88,176.19Z",
    style: {
      fill: "#FFE872"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.88,176.19c2.59,5.49.62,17.05-4.16,21.13a140,140,0,0,1-16,11.47L54,197.36s9.28-9.06,14.9-14.28A25.39,25.39,0,0,1,82.88,176.19Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54 196.63 52.92 198.1 62.03 210.01 63.32 209.09 54 196.63",
    style: {
      fill: "#FFE872"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteCreatorRafiki);
export default __webpack_public_path__ + "static/media/Website Creator-rafiki.d2f37a461c0892cd17110ac2cad0545c.svg";
export { ForwardRef as ReactComponent };